/** @format */

import React from "react";
import { MdClose } from "react-icons/md";

const SkillModal = ({ t, data, showModal, handleCancel }) => (
  <div>
    <div className="modal" style={{ display: showModal ? "block" : "" }}>
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Staff Skills</h5>
            <button
              type="button"
              className="close p-1 rounded"
              aria-label="Close"
              onClick={handleCancel}
              style={{ border: "none" }}
            >
              <MdClose />
            </button>
          </div>
          <div className="modal-body">
            {data.length ? (
              data.map(({ id, name }) => (
                <ul class="list">
                  <li key={id}>{name}</li>
                </ul>
              ))
            ) : (
              <p className="text-center">No skills available</p>
            )}
          </div>
        </div>
      </div>
    </div>
    <div className="modal-backdrop show"></div>
  </div>
);

export default SkillModal;
